import { useState } from 'react';
import { publishingApi } from '../lib/api';

/** Chaîne de publication : génération des ouvrages, éditions multilingues, prix d'accès. */
export function PublishingPage() {
  const [syllabusId, setSyllabusId] = useState('');
  const [publicationId, setPublicationId] = useState('');
  const [offeringId, setOfferingId] = useState('');
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  async function run(fn: () => Promise<any>, note: string) {
    setError(''); setNotice(''); setResult(null);
    try { const r = await fn(); setResult(r); setNotice(note); }
    catch (e: any) { setError(String(e.message || e)); }
  }

  return <section className="page">
    <header className="page-header">
      <div>
        <span className="eyebrow">PUBLICATION</span>
        <h1>Ouvrages et éditions</h1>
        <p>Génération des livres théoriques et cahiers d'exercices, éditions par langue, prix d'accès.</p>
      </div>
    </header>

    {error && <div className="alert error">{error}</div>}
    {notice && <div className="notice">{notice}</div>}

    <div className="grid two">
      <div className="card">
        <h3>Générer depuis un syllabus</h3>
        <label>Syllabus<input value={syllabusId} onChange={(e: any) => setSyllabusId(e.target.value)} placeholder="syllabus_id" /></label>
        <div className="toolbar">
          <button className="button primary" disabled={!syllabusId.trim()} onClick={() => run(() => publishingApi.generate(syllabusId.trim(), 'fr'), 'Génération lancée.')}>Générer (fr)</button>
          <button className="button secondary" disabled={!syllabusId.trim()} onClick={() => run(() => publishingApi.packageSyllabus(syllabusId.trim()), 'Paquet constitué.')}>Voir le paquet</button>
        </div>
      </div>

      <div className="card">
        <h3>Éditions par langue</h3>
        <label>Publication<input value={publicationId} onChange={(e: any) => setPublicationId(e.target.value)} placeholder="publication_id" /></label>
        <div className="toolbar">
          <button className="button secondary" disabled={!publicationId.trim()} onClick={() => run(() => publishingApi.baseEditions(publicationId.trim()), 'Éditions de base créées.')}>Éditions de base</button>
          <button className="button secondary" disabled={!publicationId.trim()} onClick={() => {
            const lang = window.prompt('Langue (ex. en, es, ht)') ?? '';
            if (lang) run(() => publishingApi.addEdition(publicationId.trim(), lang), 'Édition ajoutée.');
          }}>Ajouter une langue</button>
        </div>
      </div>
    </div>

    <div className="grid two">
      <div className="card">
        <h3>Opérations de corpus</h3>
        <p className="technical-note">Actions globales sur l'ensemble des syllabus du tenant.</p>
        <div className="toolbar">
          <button className="button secondary" onClick={() => run(() => publishingApi.normalize(), 'Modules manquants normalisés.')}>Normaliser les modules manquants</button>
          <button className="button secondary" onClick={() => run(() => publishingApi.registry({ language: 'fr', limit: 20 }), 'Registre généré.')}>Générer le registre (20)</button>
        </div>
      </div>

      <div className="card">
        <h3>Gel du syllabus d'une offre</h3>
        <p className="technical-note">Fige le syllabus pour que le contenu ne change pas en cours de session.</p>
        <label>Offre<input value={offeringId} onChange={(e: any) => setOfferingId(e.target.value)} placeholder="offering_id" /></label>
        <button className="button primary" disabled={!offeringId.trim()} onClick={() => run(() => publishingApi.freeze(offeringId.trim()), 'Syllabus gelé.')}>Geler</button>

        <h3>Prix d'accès numérique</h3>
        <div className="toolbar">
          {['MODULE_THEORY', 'MODULE_WORKBOOK'].map(k => <button key={k} className="button secondary" onClick={() => {
            const raw = window.prompt(`Montant en centimes pour ${k}`, '100');
            if (raw) run(() => publishingApi.setAccessPrice(k, Number(raw)), 'Prix mis à jour.');
          }}>{k === 'MODULE_THEORY' ? 'Livre théorique' : "Cahier d'exercices"}</button>)}
        </div>
      </div>
    </div>

    {result && <div className="card">
      <h3>Résultat</h3>
      <pre className="json-block">{JSON.stringify(result, null, 2).slice(0, 4000)}</pre>
    </div>}
  </section>;
}
